import { TransactionsApiService } from "@zenith/services/transactions";

type PaymentMethodsResponse = Awaited<
  ReturnType<typeof TransactionsApiService.getListPaymentMethod>
>;

let request: Promise<PaymentMethodsResponse> | undefined;

/**
 * The payment methods to filter transactions by. The list only changes with a
 * release, so one request serves the session; a failed one is not kept.
 */
export const getPaymentMethods = (): Promise<PaymentMethodsResponse> => {
  if (!request) {
    request = TransactionsApiService.getListPaymentMethod().catch((error) => {
      request = undefined;
      throw error;
    });
  }
  return request;
};
